import CheckboxCell from "./CheckboxCell";
import InputCell from "./InputCell";
import Table from "./Table";

export { CheckboxCell, InputCell };

export default Table;
